import { render, staticRenderFns } from "./AdminIngredient.vue?vue&type=template&id=6270250c&"
import script from "./AdminIngredient.vue?vue&type=script&lang=js&"
export * from "./AdminIngredient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports